import styled, { css } from 'styled-components';

export const StyledCounter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 2px;
  width: 156px;
  height: 48px;
`;

export const CounterButton = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.lightGreyButtonBackground};
  border: none;
  font-size: 24px;
  transition: all 0.4s;
  cursor: pointer;

  color: ${({ theme }) => theme.palette.darkGrey};
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &:disabled {
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
  }
  &:hover {
    ${({ disabled }) =>
      !disabled &&
      css`
        background-color: ${({ theme }) => theme.palette.darkGrey};
        & > span {
          span {
            svg {
              path {
                fill: ${({ theme }) => theme.palette.white};
              }
            }
          }
        }

        span {
          font-size: 24px;

          text-align: center;
        }
      `}
  }
`;

export const CounterButtonLabel = styled.span`
  margin: 0 20px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.palette.darkGray};
`;

export const TourIncrementButtonWrapper = styled.div`
  pointer-events: true;
`;
